var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _ellipse, _ellipse2, _ellipse3, _g, _g2, _path52, _path53, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifeeCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 340 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "notifee-bg_svg__a",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifee-bg_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notifee-bg_svg__b)",
    d: "M0 0h340v328H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notifee-bg_svg__c)",
    d: "M0 0h340v328H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "notifee-bg_svg__d",
    width: 483,
    height: 441,
    x: -90,
    y: -94,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M-5.312 132.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM36.828 132.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM78.977 132.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M121.148 132.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM163.297 132.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM205.438 132.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM247.617 132.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M289.758 132.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-26.602 168.609v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M15.57 168.609v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM57.719 168.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M99.867 168.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M142.039 168.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM184.188 168.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M226.328 168.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM268.508 168.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M-4.953-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM37.195-10.995v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM79.336-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M121.516-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M163.656-10.995v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM205.805-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M247.977-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM290.125-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM332.266-10.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M-5.312 204.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M36.828 204.683v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M78.977 204.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM121.148 204.683v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M163.297 204.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM205.438 204.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM247.617 204.683v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M289.758 204.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-26.227 25.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM15.93 25.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M58.094 25.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M100.234 25.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M142.398 25.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M184.555 25.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M226.703 25.033v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM268.859 25.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M311.023 25.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM-26.602 240.704v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3zM15.57 240.704v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3zM57.719 240.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3zM99.867 240.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M142.039 240.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M184.188 240.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M226.328 240.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M268.508 240.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M-4.953 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M37.195 60.808v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM79.336 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM121.516 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M163.656 60.808v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M205.805 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM247.977 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M290.125 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M332.266 60.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-5.312 276.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM36.828 276.48v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M78.977 276.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M121.148 276.48v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M163.297 276.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM205.438 276.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M247.617 276.48v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM289.758 276.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M-26.148 97.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM16 97.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M58.148 97.083v22.601l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M100.32 97.083v22.601l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M142.469 97.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M184.617 97.083v22.601l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M226.758 97.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM268.938 97.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M311.078 97.083v22.601l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M-26.516 312.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3zM15.633 312.755v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M57.79 312.755v22.6l19.774 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M99.945 312.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M142.102 312.755v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M184.242 312.755v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M226.398 312.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3zM268.562 312.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifee-bg_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__e)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.977,
    cy: 73.52,
    fill: "#fff",
    rx: 39.977,
    ry: 73.52,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 58.664 170.648)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__f)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.77,
    cy: 68.216,
    fill: "#fff",
    rx: 46.77,
    ry: 68.216,
    transform: "matrix(-.47195 .88162 -.91023 -.4141 155.656 131.641)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__g)",
    opacity: 0.8,
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.456,
    cy: 65.207,
    fill: "#fff",
    rx: 35.456,
    ry: 65.207,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 346.484 12.35)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262635",
    d: "M36.867 132.993v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#notifee-bg_svg__h)",
    strokeLinecap: "round",
    strokeOpacity: 0.58,
    d: "m56.642 166.318-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#notifee-bg_svg__i)",
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    d: "m56.642 166.318-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B29",
    d: "M15.79 168.544v22.601l19.774 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#notifee-bg_svg__j)",
    strokeLinecap: "round",
    strokeOpacity: 0.58,
    d: "M35.564 201.869 16.29 190.854v-22.02l19.275-11.014 19.276 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#notifee-bg_svg__k)",
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    d: "M35.564 201.869 16.29 190.854v-22.02l19.275-11.014 19.276 11.014v22.02z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#notifee-bg_svg__l)",
    strokeOpacity: 0.68,
    strokeWidth: 1.4,
    d: "m35.712 156.316 20.767 11.995m0 0v23.431l-20.915 11.861m20.915-35.292 19-11",
    opacity: 0.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "notifee-bg_svg__n",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notifee-bg_svg__m)",
    d: "M0 0h340v328H0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifee-bg_svg__n)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__o)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.456,
    cy: 65.207,
    fill: "#7F8AAD",
    rx: 35.456,
    ry: 65.207,
    transform: "matrix(-.58785 .80897 -.83585 -.54895 390.692 26.59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__p)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 26.876,
    fill: "#7F8AAD",
    fillOpacity: 0.8,
    rx: 25.305,
    ry: 26.876,
    transform: "matrix(-.04618 .99893 -.99983 .01835 348.273 -28.775)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#notifee-bg_svg__q)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 32.646,
    fill: "#B4BBCF",
    rx: 25.305,
    ry: 32.646,
    transform: "matrix(-.04618 .99893 -.99983 .01835 359.811 -28.987)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(150.9999 133.49996 -150.17354 169.85915 -16 49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#2A2B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#2A2B42",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-155.00068 82.99921 -86.03549 -160.67092 304 25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#373B4A",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(50.386 -94.636 84.27)scale(57.7253 64.6524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-103.486 110.57 54.752)scale(47.9532 53.7076)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(70.669 -84.676 78.49)scale(54.8142 61.3919)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notifee-bg_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.98684 -51.84025 58.0611 6.70527 44.865 215.801)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__e",
    width: 214.569,
    height: 242.417,
    x: -121.834,
    y: 5.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 27.736
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__f",
    width: 285.173,
    height: 253.313,
    x: -71.096,
    y: 17.97,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 38.335
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__g",
    width: 190.306,
    height: 215.005,
    x: 186.396,
    y: -134.026,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 24.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__o",
    width: 299.537,
    height: 274.543,
    x: 165.578,
    y: -117.793,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 45.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__p",
    width: 189.795,
    height: 186.566,
    x: 225.336,
    y: -96.287,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notifee-bg_svg__q",
    width: 201.323,
    height: 186.57,
    x: 225.34,
    y: -96.395,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2049",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notifee-bg_svg__l",
    x1: 46.291,
    x2: 45.685,
    y1: 157.747,
    y2: 200.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111219",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111219",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "notifee-bg_svg__m",
    width: 0.353,
    height: 0.366,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#notifee-bg_svg__r",
    transform: "scale(.00294 .00305)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL0SURBVHgB7drBkYRADEPRzT8DciKn3giGklBzkPu/EzXFzuLDqIzbf3+Yb611/7i+fny+ftyzhOvb/L/ud17C9xxVL4BqD1FwCddu7LiR5UbuJdRyVL0AqoVd6BV8jxtrSoepRPFR9QKo9iIWknhMOtslPHMyxBhZL4BqS3uRV67dztMdMiixdgf3j6wXQLWlvbwncaFEnPsMd/C3R9ULoJrYxSWDBSVS3CjbFYPj6wVQ7UX36B7DuQtsbky5UXxUvQCqiR2ju7GQdJLuhkMSfePrBVBNjIXkKC1ZfnO7Yjeux9cLoJoYTUlH6kaiEmtuN5vMlqvrBVBNjIUtR1fi57vmvUrMjq8XQLWHTk85Mvt69vt1Fz2+XgDVXnSDu47P3KjcNUA4ql4A1R5+8knn6cbdMu93Y80daIypF0C1Zb44h5HodrC7ulZlI2JkvQCqrWyrIbnHjVBlPuzOe8fXC6Dai59/slf8RbTuOv4bWS+Aahtjyh0m7BpKKM//RSxX1Aug2sYuUXnxd+e0bsQl2x0j6wVQTYyI5JhMiTU34pJtiqPqBVBN7PSSo7ckstzIdTvP8fUCqBZ2ocrcNXlhV4YSbhQfVS+Aai9iIYnHpLN158zJUeCYegFUW9qLvHKdbEoke8LJJsb4egFUW/6SmBsXSsS5z3AHf3tUvQCqiV1cMlhQIsWNsl0xOL5eANVedI/uMZy7wObGlBvFR9ULoJrYMbobC0kn6W44JNE3vl4A1cRYSI7SkuU3tyt243p8vQCqidGUdKRuJCqx5nazyWy5ul4A1cRY2HJ0JX6+a96rxOz4egFUe+j0lCOzr2e/X3fR4+sFUO1FN7jr+MyNyl0DhKPqBVDt4SefdJ5u3C3zfjfW3IHGmHoBVFvmi3MYiW4Hu6trVTYiRtYLoNrKthqSe9wIVebD7rx3fL0Aqr34+Sd7xV9E667jv5H1Aqi2MabcYcKuoYTy/F/EckW9AKpt7BKVF393TutGXLLdMbJeDPYPkN6qZhcPlQEAAAAASUVORK5CYII=",
    id: "notifee-bg_svg__r",
    width: 120,
    height: 120
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifeeCardBg);
export default __webpack_public_path__ + "static/media/notifee-card-bg.8cc1f6a2a4bc78051e80ca963848c9b9.svg";
export { ForwardRef as ReactComponent };